//#region src/version.ts
const version = "5.0.0-beta.0";

//#endregion
export { version };
//# sourceMappingURL=version.js.map